module.exports = __webpack_public_path__ + "static/media/Example_IQ_Link_Screenshot.b95b5465.png";